module.exports = __webpack_public_path__ + "img/industry_solution7.73003d99.png";